module.exports = __webpack_public_path__ + "img/grid-03.8aeb3330.svg";